// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskCheckmark16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-checkmark': IconFloppyDiskCheckmark;
    }
}

/**
 * The icon component for the 'floppyDiskCheckmark' icon
 */
export class IconFloppyDiskCheckmark extends Icon {
    public constructor() {
        super(floppyDiskCheckmark16X16);
    }
}

registerIcon('icon-floppy-disk-checkmark', IconFloppyDiskCheckmark);
export const iconFloppyDiskCheckmarkTag = 'nimble-icon-floppy-disk-checkmark';
